import { IssueUserApi } from "api/issuesApi";
import { UserAvatar } from "components/molecules";
import React from "react";

interface TaskCardFooterAssigneesProps {
  assignees?: IssueUserApi[];
}
export const TaskCardFooterAssignees = ({ assignees }: TaskCardFooterAssigneesProps) => {
  if (!assignees || assignees.length < 1)
    return (
      <button className="p-2 shrink-0 rounded-full bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 text-indigo-500 transition duration-150">
        <span className="sr-only">Add</span>
        <svg className="w-3 h-3 fill-current" viewBox="0 0 12 12">
          <path d="M11 5H7V1a1 1 0 00-2 0v4H1a1 1 0 000 2h4v4a1 1 0 002 0V7h4a1 1 0 000-2z" />
        </svg>
      </button>
    );

  return (
    <div className="flex shrink-0 -space-x-3 -ml-px">
      {assignees.map((user) => (
        // todo avatar
        <UserAvatar key={user.id} firstName={user.firstName} size="small" surname={user.surname} />
      ))}
    </div>
  );
};
